/**
 * Deep-link state for the governance document detail modal: `?document=<id>`.
 * Used by Document View and by the document lists on the chart pages; the
 * mechanics are shared with the incident tracker (lib/modalUrl).
 */

import { modalUrl } from './modalUrl';

export const DOCUMENT_PARAM = 'document';

export const documentUrl = modalUrl(DOCUMENT_PARAM, 'airiDocument');
